import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import MemberItem from "../MemberItem/MemberItem";
import "./ProgramMembers.css";
import Notification from "../Notification/Notification";
import { useTranslation } from "react-i18next"; // Importer useTranslation

function ProgramMembers({ members, program, setMembers }) {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const [error, setError] = useState("");
  const [notificationParams, setNotificationParams] = useState({
    show: false,
    message: t("notification_default_message"),
    bg: "success",
  });

  const handleDelete = async (id) => {
    const userId = id;
    setError("");
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/programs/users",
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ userId, programId: program.id }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || t("error_occurred"));
      }

      setMembers((prev) =>
        prev.filter((member) => {
          return member._id !== userId;
        })
      );

      setNotificationParams((prev) => ({
        show: true,
        message: data.message,
        bg: "success",
      }));
    } catch (err) {
      console.error(err);
      setError(err.message || t("error_occurred"));
      setNotificationParams((prev) => ({
        show: true,
        message: err.message,
        bg: "danger",
      }));
    }
  };

  return (
    <Container>
      <h6 className="mb-3">
        {members.length} {t("members")}
      </h6>
      <Row className="border bg-light py-2">
        <Col className="fw-bold">{t("user")}</Col>
        <Col className="fw-bold">{t("role")}</Col>
        <Col sm={1} className="fw-bold"></Col>
      </Row>
      <div className="container-members">
        {members.map((member, index) => {
          return (
            <MemberItem
              key={index}
              {...member}
              id={member._id}
              programCreator={program.created_by._id}
              handleDelete={handleDelete}
            />
          );
        })}
      </div>

      <Notification
        notificationParams={notificationParams}
        setNotificationParams={setNotificationParams}
      />
    </Container>
  );
}

export default ProgramMembers;
